import { type JSX } from 'react/jsx-runtime';

import { createRender, type HydrationResult } from './types';

import { JsmRequestResolverMessage } from '../../../common/components/JsmRequestResolverMessage';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(({ onDismissed }) => {
	return (
		<JsmRequestResolverMessage
			handleOnDismissed={onDismissed}
			context={{
				source: 'jira-side-nav',
			}}
		/>
	);
});

export default render;
